import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { provideTranslationScope, TranslationPipe } from "@ogs-gmbh/ngx-translate";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-core-ui-server-error-dialog",
  templateUrl: "server-error-dialog.component.html",
  imports: [ MatButtonModule, MatDialogModule, TranslationPipe ],
  providers: [ provideTranslationScope("core/server-error-dialog") ]
})
export class ServerErrorDialogComponent {
  private readonly dialogRef: MatDialogRef<ServerErrorDialogComponent> = inject<MatDialogRef<ServerErrorDialogComponent>>(MatDialogRef);

  close (): void {
    this.dialogRef.close();
  }
}
